import React from "react";
import {
    Dropdown,
    Button,
    Card,
    CardBody,
    CardHeader,
    Input,
    List,
    StandardListCell,
    StateListCell,
    DemandListCell
} from "gd-react";
import moment from "moment-timezone";
import Modal from "react-modal";
import GridDuck from "gridduck";

class GatewaySettingsEventLog extends React.Component {
    constructor(props) {
        super(props);
        let self = this;
        if (this.props.item) {
            this.state = {
                filters: [
                    {
                        "field": "gatewayId",
                        "value": this.props.item.id
                    },
                    {
                        "field": "start",
                        "value": 0
                    },
                    {
                        "field": "end",
                        "value": new Date().getTime() / 1000
                    }
                ]
            };
        } else {
            this.state = {};
        }
        this.getList = this.getList.bind(this);
    }

    getList(retrievalParams) {
        
        return GridDuck.getGatewayEvents(retrievalParams);
    }


    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps !== this.props) {
            let self = this;
            this.setState({
                filters: [
                    {
                        "field": "gatewayId",
                        "value": this.props.item.id
                    },
                    {
                        "field": "start",
                        "value": 0
                    },
                    {
                        "field": "end",
                        "value": Math.round(new Date().getTime() / 1000)
                    }
                ]
            });
        }
    }


    render() {
        let list;
        if (this.state && this.state.filters) {
            list = (
                <List
                    nohover
                    columns={[
                        {component: StandardListCell, sortable: false, title: 'Time', field: 'time', maxWidth: '10', custom: function (value) {return moment.unix(value.time).format('DD/MM/YYYY, HH:mm:ss')}},
                        {component: StandardListCell, sortable: false, title: 'Event', field: 'type', maxWidth: 'none'}
                    ]}
                    getlist={this.getList}
                    expanded={true}
                    itemsPerPage={20}
					filters={this.state.filters}/>
            )
        }

        return (
			<div className='page'>
                {list}
            </div>
        )
    }
}

export default GatewaySettingsEventLog;
